import { CoADocumentMigrationSource } from "@common/schemas/accounting-integration.schema";
import { ExtractionMethod } from "@common/types/financialDocument";
import { never } from "./typescript";

export function extractionMethodForMigrationSource(
    source: CoADocumentMigrationSource,
): ExtractionMethod {
    switch (source) {
        case "qbdt":
            return ExtractionMethod.QBDT;
        case "xero":
            return ExtractionMethod.XERO;
        case "qbo":
            return ExtractionMethod.QBO;
        default:
            return never(`Unsupported migration source: ${source}`);
    }
}
